// Format:
/*
{
id: ,
title: '',
data: '',
tags: [],
excerpt: '',
content: ``
}
*/

export const blogPosts = [
    // Add more blog posts as needed
];